export enum LandingType {
    LOST_PHONE = "lost_phone",
    LOCATE_NUMBER = "locate_number",
    DEFAULT = "default",
}

export enum LandingVariant {
    DEFAULT = "default",
    FAQ_V4 = "faq_4.0",
}

export enum LandingMode {
    LOCATE_NUMBER_MODE = "locate by number",
    LOST_MY_PHONE_MODE = "lost my phone",
    LOCATE_BY_LINK = "locate by link",
}
